import axios from 'axios'
import moment from 'moment'
import request from '../api/request'

const IMGPATH = '/default/'
const QINIU_UPLOAD_HOST = 'https://up-z2.qiniup.com'
const QINIU_PUBLIC_DOMAIN = 'https://sport-cdn.qietongvip.com'
export function uploadPath(path, file) {
  // 上传文件的路径，使用日期命名文件目录
  return path + `${moment().format('YYYYMMDD')}/${file.name.split('.')[0]}-${file.uid || '1'}.${file.type.split('/')[1]}`
}

async function fetchQiniuUploadToken(key) {
  const res = await request.get('/app/config/qiniuToken', { key })
  const tokenData = res && res.data
  if (!tokenData) {
    throw new Error('获取七牛上传token失败')
  }
  if (typeof tokenData === 'string') {
    return tokenData
  }
  return tokenData.token || tokenData.uploadToken || tokenData.uptoken
}

function formatQiniuFileUrl(key) {
  if (!QINIU_PUBLIC_DOMAIN) {
    return key
  }
  return `${QINIU_PUBLIC_DOMAIN.replace(/\/$/, '')}/${key}`
}

export function UploadIMGToOss(file) {
  const originFileObj = file && file.originFileObj ? file.originFileObj : file
  const key = uploadPath(IMGPATH, originFileObj)
  return new Promise(async (resolve, reject) => {
    try {
      const token = await fetchQiniuUploadToken(key)
      if (!token) {
        throw new Error('获取七牛上传token失败')
      }
      const formData = new FormData()
      formData.append('token', token)
      formData.append('key', key)
      formData.append('file', originFileObj)
      const { data } = await axios.post(QINIU_UPLOAD_HOST, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      resolve(formatQiniuFileUrl(data.key || key))
    } catch (error) {
      reject(error)
    }
  })
}

export function UploadMultipleIMGToOss(file = []) {
  const length = file.length
  let error = null
  let result = []
  file.map( (v, i) => {
    let t =  UploadIMGToOss(v)
    if (t) {
      result.push(t)
    } else {
      error = t
    }
  })
  console.log(result)
  return new Promise((resolve, reject) => {
    if (error) {
      reject(error)
    }
    if (result.length === length) {
      resolve(result)
    }
  })
}


